<div class="w-100 h-100">
    @if (fcText) {
        <simple-transport-tiny class="w-100 h-100" [valueChanged]="valueChangedTrigger" [content]="fcText">
        </simple-transport-tiny>
    }
</div>
